import {Typography, VARIANTS} from '@/components/base/typography/Typography';
import {Section, SECTION_STYLES} from '@/components/common/section/Section';
import {useMediaQueryMatch} from '@/hooks/use-media-query-match';
import {typography} from '@/utilites/typography/typography';

import {Card} from './components/Card/Card';
import {data} from './const';
import styles from './SurveyFeats.module.css';

export function SurveyFeats() {
	const [isDesktop] = useMediaQueryMatch('(min-width: 1440px)');

	return (
		<Section style={SECTION_STYLES.WITH_BREAKPOINTS} className={styles.root}>
			<Typography as="h2" className={styles.title} variant={VARIANTS.h1}>
				{isDesktop ? (
					<>
						{typography(
							'Проводите корпоративные опросы и повышайте эффективность внутренних процессов компании',
						)}
					</>
				) : (
					<>
						Проводите корпоративные опросы
						<br />
						и повышайте эффективность
						<br />
						внутренних процессов компании
					</>
				)}
			</Typography>
			<ul className={styles.content}>
				{data.map((item) => (
					<Card {...item} key={item.id} />
				))}
			</ul>
		</Section>
	);
}
